import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/catalogos/uma-valor';

/**
 * GET UMAS Valores
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUmasValores = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET UMA Valor
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getUmaValor = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST UMA Valor
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUmaValor = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH UMA Valor
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchUmaValor = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE UMA Valor
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteUmaValor = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
